import { render, staticRenderFns } from "./transferKlpt.vue?vue&type=template&id=4958d63d"
import script from "./transferKlpt.vue?vue&type=script&lang=js"
export * from "./transferKlpt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports